export const API = {
  WAPI: process.env.REACT_APP_WAPI,
  eventCollector: process.env.REACT_APP_EVENT_COLLECTOR,
  getFileUsingGUID: process.env.REACT_APP_GET_FILE_GUID,
  providerNode: process.env.REACT_APP_PROVIDER_NODE,
  s3_doctor_images_bucket:process.env.REACT_APP_S3_DOCTOR_PHOTO_BUCKET,
  infiniNode_Backend: process.env.REACT_APP_INFINI_NODE_BACKEND,
  views_medibuddy_url:process.env.REACT_APP_VIEWS_MEDIBUDDY_URL,
  consults_core_backend: process.env.REACT_APP_CONSULTS_CORE_BACKEND
};
